import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useModalProps } from '@kallidus/common';
import ContactUsModal from '@Generic/ContactUsModal';
import { useAppConfig } from '@ApplicationWide/AppConfig';
import { getDatesDifferenceInDays } from '@Utils/isCompanyTrialOrDateDifference';

const CompanyTrialExpired = () => {
  const { t } = useTranslation();
  const { company } = useAppConfig();
  const { openModal, modalProps } = useModalProps();

  useEffect(() => {
    if (company?.baseDetails?.accountType === 'trial' && getDatesDifferenceInDays(company) <= 0) openModal();
  }, [company, openModal]);

  if (company) {
    return (
      <ContactUsModal
        title={t('company-trial.expire-account-title')}
        subTitle={t('company-trial.expire-account-description')}
        message={t('company-trial.modals.request-quote.placeholder-message')}
        isExpireTrial={true}
        {...modalProps}
      />
    );
  }
  return false;
};

export default CompanyTrialExpired;
